import { useTranslation } from "react-i18next";

const KEYS = ["marquee.m1", "marquee.m2", "marquee.m3", "marquee.m4", "marquee.m5", "marquee.m6"];

const Row = ({ ariaHidden = false, items }) => (
  <div aria-hidden={ariaHidden} className="flex shrink-0 items-center">
    {items.map((item, i) => (
      <span key={i} className="flex items-center">
        <span className="whitespace-nowrap px-8 font-serif text-2xl italic text-ivoire/90 lg:text-3xl">
          {item}
        </span>
        <span className="inline-block h-2 w-2 rotate-45 border border-or" />
      </span>
    ))}
  </div>
);

export const Marquee = () => {
  const { t } = useTranslation();
  const items = KEYS.map((k) => t(k));
  return (
    <div
      data-testid="editorial-marquee"
      className="group relative flex overflow-hidden border-y border-ligne bg-card2 py-6"
    >
      <div className="flex animate-marquee-scroll group-hover:[animation-play-state:paused]">
        <Row items={items} />
        <Row items={items} ariaHidden />
      </div>
    </div>
  );
};
